import { __decorate } from "tslib";
import { Component, ViewEncapsulation, } from '@angular/core';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { SharedHttp } from '../../../services/http-client.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth.service';
import { UtilityService } from '../../../services/utility.service';
/**
 * NewBankAccount Component
 */
let NewBankAccountComponent = class NewBankAccountComponent {
    constructor(httpClient, sanitizer, themeService, auth, utilityService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.auth = auth;
        this.utilityService = utilityService;
        this.bankAccounts = [];
        this.cryptoAccounts = [];
        this.mainColor = '';
        this.accentColor = '';
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.inputTextColor = '';
        this.inputBackColor = '';
        this.successColor = '';
        this.user = {};
        this.loggedIn = false;
        this.borderRadiusLarger = '';
        this.validBankAccount = true;
        this.errorColor = '';
        this.secondColor = '';
        this.bank_account = '';
        this.reference = '';
        this.accountNameEmpty = false;
        this.errorMessage = '';
        this.auth.fetchUser().then(() => {
            this.user = JSON.parse(localStorage.getItem('user'));
        });
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
        });
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
    }
    ngOnInit() {
    }
    errors() {
        return !!(!this.user || !this.validBankAccount || this.accountNameEmpty || this.errorMessage);
    }
    validateBankAccount() {
        if (this.bank_account !== this.previousBankAccount) {
            this.errorMessage = '';
        }
        this.previousBankAccount = this.bank_account;
        this.utilityService.validateBankAccount(this.bank_account).then(result => {
            this.validBankAccount = result.validBankAccount;
            this.bank_account = result.formatedBankAccount;
        });
    }
    validateAccountName() {
        if (this.reference == '' || this.reference == null) {
            this.accountNameEmpty = true;
        }
        else {
            this.accountNameEmpty = false;
        }
    }
    submit() {
        if (this.reference == '' || this.reference == null) {
            this.accountNameEmpty = true;
            return;
        }
        else {
            this.accountNameEmpty = false;
        }
        this.utilityService.validateBankAccount(this.bank_account).then(result => {
            this.validBankAccount = result.validBankAccount;
            this.bank_account = result.formatedBankAccount;
            if (this.validBankAccount) {
                this.httpClient.post('user/addbankaccount', {
                    bank: '',
                    account: this.bank_account,
                    reference: this.reference,
                }).subscribe((data) => {
                    this.success();
                    this.close();
                }, error => {
                    this.errorMessage = error.error[0];
                });
            }
        });
    }
    close() {
        this.modal.destroy();
    }
};
NewBankAccountComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: AuthService },
    { type: UtilityService }
];
NewBankAccountComponent = __decorate([
    Component({
        selector: 'ecd-new-bank-account',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./new-bank-account.component.html")).default
    })
], NewBankAccountComponent);
export { NewBankAccountComponent };
